<!-- src/components/sections/WhyItStalls.svelte -->
<script>
  import fixes from '../../content/fixes.json';
</script>

<section class="stalls" id="why-it-stalls" aria-labelledby="stalls-heading">
  <div class="container">
    <h2 id="stalls-heading" class="section_heading marker-font">{fixes.heading}</h2>
    <p class="section_intro">{fixes.intro}</p>

    <ul class="fix_list">
      {#each fixes.items as item}
        <li class="fix_item">
          <p class="fix_problem">{item.problem}</p>
          <p class="fix_fix">{item.fix}</p>
        </li>
      {/each}
    </ul>

    <p class="closer">{fixes.closer}</p>
  </div>
</section>

<style>
  .stalls {
    background: var(--color-card-bg);
    padding: 5rem 0;
  }

  .container {
    max-width: 900px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .section_heading {
    font-size: 2.75rem;
    line-height: 1.15;
    color: var(--color-text);
    margin-bottom: 1rem;
    text-align: center;
  }

  .section_intro {
    font-size: 1.2rem;
    line-height: 1.6;
    color: var(--color-text-muted);
    max-width: 760px;
    margin: 0 auto 3rem;
    text-align: center;
  }

  .fix_list {
    list-style: none;
    padding: 0;
    margin: 0 0 3rem;
    display: grid;
    gap: 1rem;
  }

  .fix_item {
    background: var(--color-background);
    border-left: 4px solid var(--color-secondary);
    border-radius: 8px;
    padding: 1.5rem 1.75rem;
  }

  .fix_problem {
    font-size: 1.15rem;
    font-weight: 600;
    color: var(--color-secondary);
    margin: 0 0 0.4rem;
  }

  .fix_fix {
    font-size: 1.1rem;
    line-height: 1.55;
    color: var(--color-text);
    margin: 0;
  }

  .closer {
    font-size: 1.3rem;
    line-height: 1.5;
    color: var(--color-text);
    text-align: center;
    max-width: 760px;
    margin: 0 auto;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    .stalls {
      padding: 3.5rem 0;
    }

    .section_heading {
      font-size: 2rem;
    }

    .section_intro {
      font-size: 1.05rem;
    }

    .closer {
      font-size: 1.15rem;
    }
  }
</style>
